import { Application } from "@hotwired/stimulus"

const application = Application.start()

application.debug = false
window.Stimulus = application

// Register view controllers with the naming convention Phlex expects: views--{path}
const viewControllers = import.meta.glob('../views/**/controller.js', { eager: true })
for (const path in viewControllers) {
    const controller = viewControllers[path].default

    // Convert path like "../views/components/element/modal/controller.js"
    // to controller name "views--components--element--modal"
    const relativePath = path
        .split("/views/")[1]
        .replace("/controller.js", "")
        .replace(/\//g, "--")
        .replace(/_/g, "-")

    const controllerName = `views--${relativePath}`
    application.register(controllerName, controller)
}

export { application }
